export enum TipoTempoEntrega {
    FIXO = "FIXO",
    PREPARO_MAIS_ROTA = "PREPARO_MAIS_ROTA"
}

export enum TipoTempoEntregaTitulo {
    FIXO = "Tempo fixo",
    PREPARO_MAIS_ROTA = "Preparo + tempo de rota"
}

export enum TipoTempoEntregaDescricao {
    FIXO = "Configure tempos mínimos e máximos fixos para entrega e retirada.",
    PREPARO_MAIS_ROTA = "O tempo de rota calculado pelo Google é somado ao tempo de preparo com um percentual de tolerância."
}
